/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useContext} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_LOGOUT, API_UPLOADS } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useHistory, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import {decode} from 'html-entities';
import {reactLocalStorage} from 'reactjs-localstorage';
import Tour from 'reactour'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Context]
-------------------------------------------------------------------*/
import { UserContext, NotificationContext, LocationContext } from '../../../context/container'
/*------------------------------------------------------------------
[End Context]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Redux]
-------------------------------------------------------------------*/
import {useSelector, useDispatch} from 'react-redux';
import { _action_user } from '../../../redux/store';
/*------------------------------------------------------------------
[End Redux]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Loading]
-------------------------------------------------------------------*/
import ReactLoading from 'react-loading';
/*------------------------------------------------------------------
[End Loading]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, YEAR } from "../../../functions";
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Sub Screen]
-------------------------------------------------------------------*/

// admin
import SimprAdmin from '../@simpr/admin'

/*------------------------------------------------------------------
[End Sub Screen]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Style]
-------------------------------------------------------------------*/
import '../../../style/general/node.entry.css';
import '../../../style/admin/node.admin.css';
/*------------------------------------------------------------------
[End Style]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import OverlayBg from '../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress, setting}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [tour, set_tour] = useState(false);

	const [loading_stuck, set_loading_stuck] = useState(false);
    const [refresh, set_refresh] = useState(null);

    const [bamboo_user, set_bamboo_user] = useState('');
    const [bamboo_update, set_bamboo_update] = useState('');

    const [bubble_active, set_bubble_active] = useState('_bb-bubble');
    const [bubble_active_top, set_bubble_active_top] = useState('_bb-bubble-top');
    const [bubble_active_left, set_bubble_active_left] = useState('_bb-bubble-left');
    const [bubble_active_top_link, set_bubble_active_top_link] = useState('_bb-tooltip _bb-tooltip-left');
    const [bubble_active_left_link, set_bubble_active_left_link] = useState('_bb-tooltip _bb-tooltip-top');

    const [toggle, set_toggle] = useState('_toggle');
    const [sidebar, set_sidebar] = useState('_sidebar');
    const [overlay_close, set_overlay_close] = useState(false);

    const [routes, set_routes] = useState('home');

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);

    const [data, set_data] = useState(null);
    const [search, set_search] = useState('');

    const [name, set_name] = useState('');
    const [password, set_password] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___selector',
          content: 'Tour Guide',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Redux]
    ----------------------------------------------------------------*/
	const dispatch = useDispatch();

    const redux_user = useSelector(state => state.user);

	const _set_redux_user = (data) => {
		dispatch(_action_user(data, 'data'))
	}
    /*--------------------------------------------------------------
    [End Redux]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Context]
    ----------------------------------------------------------------*/
    const { user, set_user } = useContext(UserContext);
    const { notification, set_notification } = useContext(NotificationContext);
    const { location, set_location } = useContext(LocationContext);
    /*--------------------------------------------------------------
    [End Context]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _logout = () => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_LOGOUT('simpr/logout__________')
        .then((response) => {
			console.log('logout : ', response.data)
            if(response.data.result === 'success'){
                _socket_offline()
                set_location('client')
                set_user('public')
                reactLocalStorage.clear();
                set_loading_stuck(false)
            }else if(response.data.error){
                if(response.data.error === 'Token Denied'){
                    set_location('client')
                    set_user('public')
                    reactLocalStorage.clear();
                    set_loading_stuck(false)
                }else{
                    error(response.data.error)
                }
            }else{
                error('Error Server')
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})
        
    }

    const _uploads_post = () => {

        if(loading === true){
            return 
        }

		loading(true);

		API_POST('simpr/user/post__________', {
            bamboo_user: bamboo_user,
            action: 'update',
            name: name,
            password: password
		}).then((response) => {
            console.log('response : ', JSON.stringify(response.data, undefined, 2))
            if(response.data.result == 'success'){
                reactLocalStorage.clear();
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket_offline = () => {

        socket.emit("simpr_user_authentication", {
            action: 'disconnect',
            room: 'room_simpr_user_authentication',
            status: 'offline',
            bamboo_user : STORAGE_USER[0].bamboo,
            username : STORAGE_USER[0].username,
            name : STORAGE_USER[0].name,
            e_account : STORAGE_USER[0].e_account,
        });

    }
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _bubble = () => {
        if(bubble_active === '_bb-bubble'){
            set_bubble_active('_bb-bubble _bb-bubble-active')
            set_bubble_active_top('_bb-bubble-top _bb-bubble-show')
            set_bubble_active_left('_bb-bubble-left _bb-bubble-show')

            set_bubble_active_top_link('_bb-tooltip _bb-tooltip-left _bb-bubble-show')
            set_bubble_active_left_link('_bb-tooltip _bb-tooltip-top _bb-bubble-show')
        }else{
            set_bubble_active('_bb-bubble')
            set_bubble_active_top('_bb-bubble-top')
            set_bubble_active_left('_bb-bubble-left')
            
            set_bubble_active_top_link('_bb-tooltip _bb-tooltip-left')
            set_bubble_active_left_link('_bb-tooltip _bb-tooltip-top')
        }
    }

    const _toggle = () => {

        if(toggle === '_sidebar'){
            set_toggle(false)
            set_sidebar('_sidebar')
            set_overlay_close(false);
        }else{
            set_toggle(true)
            set_sidebar('_sidebar _active')
            set_overlay_close(true);
        }

    }

    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    if(STORAGE_USER !== undefined){
        if(STORAGE_USER[0].level === 'guest'){
            history.push('/')
            set_location('public')
        }
    }else{
        history.push('/home')
    }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        let storage_bamboo = STORAGE_USER[0].bamboo;
        
        if(storage_bamboo){
            set_bamboo_user(storage_bamboo)
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        _STORAGE_USER()
        
        setTimeout(() => {
            
            set_loading_stuck(true) 
            
        }, 2500);

        set_location(history.location.pathname)

    }, [refresh])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Render]
    ----------------------------------------------------------------*/
    return (
        
        <>

            <Tour steps={steps} isOpen={tour} onRequestClose={() => set_tour(false)}/>
            <Tour disableKeyboardNavigation={['esc']} />

            {

                !loading_stuck &&
                <div className="_app_loading">
                    <div className="_position_middle">
                        <ReactLoading type={'cylon'} color={'#222'} height={50} width={50} />
                        <h2 style={{marginBottom: 6}}><span style={{color: '#118ab2'}}>e-</span>Configuration</h2>
                        <p>Saving Data . . .</p>
                    </div>				
                </div>	
            }

            <div className="_bb-background" style={{backgroundImage: `url(${API_UPLOADS + setting.background})`}}></div>
            
            <div className="_bb-position-overlay">

                {
                    overlay_close &&
                    <div onClick={() => {
                        set_sidebar('_sidebar')
                        set_overlay_close(false);
                    }} style={{position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10}}>

                    </div>
                }
                <div className={sidebar}>
                    <div className="_header">
                        {
                            STORAGE_USER &&
                            <>

                                <div className="_profile">
                                    <p className="_position_middle" style={{fontSize: 60}}>{STORAGE_USER[0].username.charAt(0)}</p>
                                    <div className="_profile_upload" onClick={() => {
                                            set_bamboo_update(STORAGE_USER[0].bamboo)
                                            set_name(STORAGE_USER[0].name)
                                        }}>
                                        <ion-icon name="pencil-outline"></ion-icon>
                                    </div>
                                </div>
                                <div className="_push_t_s">
                                    <p className="_center_text" style={{maxWidth: 200, margin: 'auto'}}>{STORAGE_USER[0].name}</p>
                                </div>

                                {/* <p className="_push_t_s">{STORAGE_USER[0].username}</p> */}

                            </>
                        }
                    </div>
                    <div className="_lily_pad_v_m">
                        <div onClick={() => {
                            set_element(null)
                            set_routes('home')
                        }} className="_link_hooks _cursor_pointer">
                            <div className="_row _center_align">
                                <div className="_push_r_m">
                                    <ion-icon name="home-outline" style={{color: routes === 'home' ? '#118ab2' : 'inherit', fontSize: 20}}></ion-icon>
                                </div>
                                <div className="_column" style={{color: routes === 'home' ? '#118ab2' : 'inherit'}}>
                                    Home
                                </div>
                            </div>
                        </div>

                        {
                            user && user[0].level === 'admin' &&
                            <div style={{borderWidth: 1, borderColor: '#eee', borderRightWidth: 0, borderLeftWidth: 0, borderStyle: 'solid', padding: 20, paddingTop: 10, paddingBottom: 10, marginTop: 10, marginBottom: 10}}>
                                Tour Guide
                            </div>
                        }

                        {
                            user && user[0].level === 'admin' &&
                            <div onClick={() => {
                                set_tour(true)
                            }} className="_link_hooks _cursor_pointer ___step_menu_guide">
                                <div className="_row _center_align">
                                    <div className="_push_r_m">
                                        <ion-icon name="footsteps-outline" style={{color: 'inherit', fontSize: 20}}></ion-icon>
                                    </div>
                                    <div className="_column" style={{color: 'inherit'}}>
                                        Menu Guide
                                    </div>
                                </div>
                            </div>
                        }

                        <div style={{borderWidth: 1, borderColor: '#eee', borderRightWidth: 0, borderLeftWidth: 0, borderStyle: 'solid', padding: 20, paddingTop: 10, paddingBottom: 10, marginTop: 10, marginBottom: 10}}>
                            System
                        </div>

                        <div onClick={() => _logout()} className="_link_hooks _cursor_pointer ___step_logout">
                            <div className="_row _center_align">
                                <div className="_push_r_m">
                                    <ion-icon name="log-out-outline" style={{color: 'inherit', fontSize: 20}}></ion-icon>
                                </div>
                                <div className="_column">
                                    Logout
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="_content">

                    <div style={{position: 'absolute', top: 18, right: 20, zIndex: 1}} className="_toggle_sidebar" onClick={() => _toggle()}>
                        <ion-icon name="menu-outline"></ion-icon>
                    </div>

                    {
                        bamboo_update.length > 0 &&
                        <>
                            <div className="_bb_modal_overlay">
                                <div className="_bb_modal_nav">
                                    <div className="_row _center_align">
                                        <div className="_column">
                                            <h3>Perbaharui Data</h3>
                                        </div>
                                        <div onClick={() =>
                                            {
                                                set_bamboo_update('')
                                                set_refresh(random_character(16))
                                                set_routes('home')
                                            } 
                                        }  className="_btn _cursor_pointer" style={{backgroundColor: '#fff', borderColor: '#eee'}}>
                                            Keluar
                                        </div>
                                    </div>
                                </div>
                                <div style={{borderWidth: 1, borderColor: '#eee', borderBottomStyle: 'solid'}} />
                                <div className="_bb_modal_body">
                                    <div className="_container">
                                        <div className="_lily_pad_h_d">
                                            <div className="_row _push_t_g _push_b_g">
                                                <div className="_column">
                                                    <div className="_heading_bold _push_b_d">
                                                        Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                                    </div>
                                                    <p style={{maxWidth: 300, marginBottom: 32, color: '#666'}}>Perubahan apapun akan membuat system mereset token, untuk login kembali</p>
                                                    <div className="_relative _push_b_d">
                                                        <p style={{color: '#888', fontSize: 13}}>
                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                            Name
                                                        </p>
                                                        <div className="_e_input">
                                                            <input 
                                                                placeholder=""
                                                                type={'text'} 
                                                                onChange={e => set_name(e.target.value)}
                                                                value={name}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="_relative _push_b_d">
                                                        <p style={{color: '#888', fontSize: 13}}>
                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                            Password
                                                        </p>
                                                        <div className="_e_input">
                                                            <input 
                                                                placeholder=""
                                                                type={'password'} 
                                                                onChange={e => set_password(e.target.value)}
                                                                value={password}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div onClick={() => {
                                                        _uploads_post('update')
                                                    }} className="_btn _cursor_pointer">
                                                        Simpan
                                                    </div>
                                                </div>
                                                <div className="_fmc_overlay_bg_hide">
                                                    <img style={{width: 400}} src={OverlayBg}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    
                    }
                    
                    {
                        user ?
                            user[0].level === 'admin' ?
                                <SimprAdmin
                                    loading={(e) => {loading(e)}}
                                    error={(e) => error(e)} 
                                    progress={(e) => progress(e)} 
                                />
                            : null
                        : null
                    }
                </div>
            </div>

        </>
    );
    /*--------------------------------------------------------------
    [End Render]
    ----------------------------------------------------------------*/

}

export default Screen;